var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRetroTv(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 204,
    viewBox: "0 0 200 204",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_361_741)",
    filter: "url(#filter0_d_361_741)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_361_741)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M82.0173 139.653C81.1741 139.653 80.3543 139.375 79.6844 138.863C79.0145 138.35 78.5318 137.63 78.3106 136.815L70.1975 107.126L63.1533 117.496C62.8003 118.015 62.3261 118.44 61.7719 118.733C61.2176 119.026 60.6002 119.179 59.9734 119.179H40.0634C39.0437 119.179 38.0656 118.773 37.3445 118.051C36.6235 117.329 36.2183 116.349 36.2183 115.328C36.2183 114.307 36.6235 113.327 37.3445 112.605C38.0656 111.883 39.0437 111.477 40.0634 111.477H57.9393L68.5287 95.8896C68.9428 95.283 69.5215 94.8076 70.1966 94.5197C70.8717 94.2318 71.615 94.1434 72.3386 94.2649C73.0623 94.3863 73.7361 94.7126 74.2806 95.2052C74.8251 95.6978 75.2175 96.3361 75.4114 97.0448L80.783 116.684L85.674 81.3261C85.7895 80.4852 86.1791 79.7061 86.7824 79.1099C87.3856 78.5137 88.1686 78.1338 89.0097 78.0293C89.8508 77.9248 90.7028 78.1015 91.4333 78.532C92.1637 78.9624 92.7317 79.6225 93.0489 80.4096L103.008 104.977H124.859C125.879 104.977 126.857 105.383 127.578 106.105C128.299 106.827 128.704 107.807 128.704 108.828C128.704 109.849 128.299 110.829 127.578 111.551C126.857 112.273 125.879 112.679 124.859 112.679H100.416C98.8511 112.679 97.4438 111.732 96.8517 110.28L91.3224 96.629L85.8239 136.33C85.574 138.14 84.0898 139.526 82.2634 139.642C82.1826 139.65 82.098 139.653 82.0173 139.653ZM173 184.984V194.149C173 196.267 171.27 198 169.155 198H153.659C152.275 198 150.968 197.23 150.314 196.036L144.162 184.984H173ZM61.8382 184.984L55.6861 196.036C55.3522 196.631 54.8665 197.126 54.2788 197.471C53.691 197.816 53.0222 197.999 52.3408 198H36.8451C34.7303 198 33 196.267 33 194.149V184.984H61.8382ZM167.675 110.184C170.431 110.184 172.673 107.939 172.673 105.178C172.673 102.397 170.431 100.133 167.675 100.133C164.898 100.133 162.637 102.397 162.637 105.178C162.637 107.939 164.898 110.184 167.675 110.184Z",
    fill: "#F1B359"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_361_741)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M175.695 41H25.3052C20.7156 41 16.3139 42.823 13.0686 46.068C9.82322 49.313 8 53.7141 8 58.3032V160.697C8 165.286 9.82322 169.687 13.0686 172.932C16.3139 176.177 20.7156 178 25.3052 178H175.695C180.284 178 184.686 176.177 187.931 172.932C191.177 169.687 193 165.286 193 160.697V58.3032C193 53.7141 191.177 49.313 187.931 46.068C184.686 42.823 180.284 41 175.695 41ZM168.353 59.3399C171.729 59.3501 174.964 60.6985 177.348 63.0896C179.733 65.4807 181.071 68.7193 181.071 72.0957C181.071 79.1095 175.367 84.813 168.353 84.813C164.976 84.8141 161.736 83.4758 159.344 81.0917C156.953 78.7076 155.604 75.4724 155.595 72.0957C155.599 68.7139 156.945 65.4718 159.336 63.0805C161.728 60.6892 164.97 59.344 168.353 59.3399ZM168.353 93.0831C171.729 93.0933 174.964 94.4417 177.348 96.8328C179.733 99.2239 181.071 102.463 181.071 105.839C181.071 112.853 175.367 118.556 168.353 118.556C164.976 118.557 161.736 117.219 159.344 114.835C156.953 112.451 155.604 109.216 155.595 105.839C155.599 102.457 156.945 99.215 159.336 96.8237C161.728 94.4324 164.97 93.0872 168.353 93.0831ZM136.267 152.835C101.683 164.628 64.1665 164.628 29.5833 152.835C19.5625 121.35 19.5625 97.6498 29.5833 66.1263C64.173 54.3725 101.677 54.3725 136.267 66.1263C146.287 97.6498 146.287 121.312 136.267 152.835ZM178.921 160.042H157.746C156.724 160.042 155.743 159.636 155.021 158.913C154.298 158.19 153.892 157.21 153.892 156.188C153.892 155.166 154.298 154.186 155.021 153.463C155.743 152.74 156.724 152.334 157.746 152.334H178.921C179.943 152.334 180.923 152.74 181.646 153.463C182.369 154.186 182.775 155.166 182.775 156.188C182.775 157.21 182.369 158.19 181.646 158.913C180.923 159.636 179.943 160.042 178.921 160.042ZM178.921 143.32H157.746C156.724 143.32 155.743 142.914 155.021 142.192C154.298 141.469 153.892 140.489 153.892 139.467C153.892 138.445 154.298 137.464 155.021 136.742C155.743 136.019 156.724 135.613 157.746 135.613H178.921C179.943 135.613 180.923 136.019 181.646 136.742C182.369 137.464 182.775 138.445 182.775 139.467C182.775 140.489 182.369 141.469 181.646 142.192C180.923 142.914 179.943 143.32 178.921 143.32Z",
    fill: "#F1B359"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_361_741)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M167.988 77C170.752 77 173 74.7449 173 71.9714C173 69.1786 170.752 66.9041 167.988 66.9041C165.204 66.9041 162.937 69.1786 162.937 71.9714C162.937 74.7449 165.204 77 167.988 77ZM153.124 13.6432C153.124 20.0644 147.919 25.2864 141.519 25.2864C138.087 25.2864 134.964 23.7391 132.921 21.3409L119.195 26.3695C121.508 28.2649 123.552 30.5084 125.325 33.0227H68.8401C70.3438 30.9339 72.0403 29.0385 73.891 27.3752L60.2035 22.3079C59.1251 23.5396 57.7965 24.5256 56.3068 25.1994C54.8171 25.8733 53.201 26.2195 51.5669 26.2148C45.2051 26.2148 40 20.9927 40 14.6102C40 8.18908 45.2051 2.96704 51.5669 2.96704C57.9672 2.96704 63.1338 8.18908 63.1338 14.6102C63.1338 14.8037 63.1338 14.9584 63.0952 15.1518L81.795 21.9985C86.4989 19.6775 91.704 18.4397 97.1019 18.4397C101.883 18.4397 106.51 19.4068 110.751 21.2635L130.029 14.1847C129.99 13.9913 129.99 13.8366 129.99 13.6432C129.99 7.22203 135.157 2 141.519 2C147.919 2 153.124 7.22203 153.124 13.6432Z",
    fill: "#F1B359"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_361_741",
    x: -6,
    y: 0,
    width: 206,
    height: 206,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -3,
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_361_741"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_361_741",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_361_741",
    x: 27,
    y: 78,
    width: 146,
    height: 126,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -3,
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_361_741"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_361_741",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_361_741",
    x: 2,
    y: 41,
    width: 191,
    height: 143,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -3,
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_361_741"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_361_741",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_361_741",
    x: 34,
    y: 2,
    width: 139,
    height: 81,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -3,
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_361_741"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_361_741",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_361_741"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 200,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRetroTv);
export default __webpack_public_path__ + "static/media/retroTv.7afff8920358a7d05d2fdcb129809e0a.svg";
export { ForwardRef as ReactComponent };